import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";

export const RealtyAllRiskReinsuranceDescription = () => {
  const { t } = useTranslation();

  return (
    <Descriptions
      size="small"
      column={1}
      style={{ width: 500 }}
      bordered
      items={[
        {
          label: t("calc.realty.helpers.allRiskReinsuranceDesc.institution1"),
          children: t("calc.realty.helpers.allRiskReinsuranceDesc.value1"),
        },
        {
          label: t("calc.realty.helpers.allRiskReinsuranceDesc.institution2"),
          children: (
            <>
              {t("calc.realty.helpers.allRiskReinsuranceDesc.value2.text")}
              <ul style={{ marginBottom: 0 }}>
                {[1, 2, 3].map((value) => (
                  <li key={value}>{t("calc.realty.helpers.allRiskReinsuranceDesc.value2.item" + value)}</li>
                ))}
              </ul>
            </>
          ),
        },
      ]}
    />
  );
};
